import { getSwappedValues } from "@draftkings/sportsbook-common-utils";
import { formatDate } from "../formatDate";
import { parseScoreboards } from "../parseScoreboards";
import { getTeamIconUrl, isSettledStatus } from "../../helpers";
export function parseEvent(event, status, teamLogos, dateFormatter, dictionary, staticS3Host, swooshFeatureFlag, swooshBaseUrl) {
    const parser = mapEventParser[event.eventType] || parseOutrightEvent;
    return parser(event, status, teamLogos, dateFormatter, dictionary, staticS3Host, swooshFeatureFlag, swooshBaseUrl);
}
const mapEventParser = {
    Fixture: parseFixtureEvent,
    Outright: parseOutrightEvent
};
function parseFixtureEvent(event, _status, teamLogos, dateFormatter, dictionary, staticS3Host, swooshFeatureFlag, swooshBaseUrl) {
    var _a, _b, _c, _d;
    const [team1Name, team2Name] = getSwappedValues(event.isTeamSwap, event.homeTeamName, event.awayTeamName);
    const scoreboards = parseScoreboards(event, dictionary);
    const team1 = (_a = event.participants) === null || _a === void 0 ? void 0 : _a.find(participant => participant.name === team1Name);
    const team2 = (_b = event.participants) === null || _b === void 0 ? void 0 : _b.find(participant => participant.name === team2Name);
    const team1IconUrl = getTeamIconUrl({
        swooshFeatureFlag,
        swooshBaseUrl,
        rosettaTeamId: (_c = team1 === null || team1 === void 0 ? void 0 : team1.metadata) === null || _c === void 0 ? void 0 : _c.rosettaTeamId,
        staticS3Host,
        teamLogos,
        leagueId: event.leagueId,
        teamName: team1Name,
        isNationalTeam: team1 === null || team1 === void 0 ? void 0 : team1.isNationalTeam,
        countryCode: team1 === null || team1 === void 0 ? void 0 : team1.countryCode
    });
    const team2IconUrl = getTeamIconUrl({
        swooshFeatureFlag,
        swooshBaseUrl,
        rosettaTeamId: (_d = team2 === null || team2 === void 0 ? void 0 : team2.metadata) === null || _d === void 0 ? void 0 : _d.rosettaTeamId,
        staticS3Host,
        teamLogos,
        leagueId: event.leagueId,
        teamName: team2Name,
        isNationalTeam: team2 === null || team2 === void 0 ? void 0 : team2.isNationalTeam,
        countryCode: team2 === null || team2 === void 0 ? void 0 : team2.countryCode
    });
    return Object.assign({ sportId: event.sportId, eventId: event.eventId, eventDisplayName: event.eventDisplayName, eventType: "Fixture", team1IconUrl,
        team1Name,
        team2IconUrl,
        team2Name, formattedStartEventDate: formatDate(event.eventStartDate, dateFormatter), isLive: event.isLive, status: event.status, isTeamSwap: event.isTeamSwap }, scoreboards);
}
function parseOutrightEvent(event, status, _, dateFormatter, dictionary) {
    return {
        sportId: event.sportId,
        eventId: event.eventId,
        eventDisplayName: event.eventDisplayName,
        eventType: "Outright",
        formattedStartEventDate: formatDate(event.eventStartDate, dateFormatter),
        isLive: event.isLive,
        shortLabel: event.isLive || !isSettledStatus(status) ? "" : dictionary.myBetsDictionary.BetsEnded,
        status: event.status,
    };
}
//# sourceMappingURL=parseEvent.js.map